/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';


import BaseInput from './BaseInput';
import NumberInput from './NumberInput';
import DollarInput from './DollarInput';
import DateInput from './DateInput';
import PhoneNumberInput from './PhoneNumberInput';
import PercentInput from './PercentInput';


const parseReduxFormValue = (value, regexSymbols) => {
  const floatValue = parseFloat(value.replace(regexSymbols, ''));

  if (Number.isFinite(floatValue)) {
    return floatValue;
  }

  return null;
};
/*
* BaseField
 */
export const BaseField = (props) => {
  const {
    name,
    label,
    componentClass,
    componentProps,
    validate,
  } = props;

  return (
    <Field
      name={name}
      component={BaseInput}
      validate={validate}
      componentClass={componentClass}
      componentProps={componentProps}
      label={label}
    />
  );
};


BaseField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  componentClass: PropTypes.oneOf(['input', 'textarea']),
  componentProps: PropTypes.object,
  validate: PropTypes.any,
};


BaseField.defaultProps = {
  label: null,
  componentClass: 'input',
  componentProps: {},
  validate: [],
};


/*
* NumberField
 */
export const NumberField = (props) => {
  const { componentProps, name, label } = props;

  const format = (value) => { return String(value); };
  const parse = (value) => { return parseFloat(value); };

  return (
    <Field
      name={name}
      component={NumberInput}
      componentProps={componentProps}
      format={format}
      parse={parse}
      label={label}
    />
  );
};


NumberField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  componentProps: PropTypes.object,
};


NumberField.defaultProps = {
  label: null,
  componentProps: {},
};


/*
* DollarField
 */
export const DollarField = (props) => {
  const { componentProps, name, label } = props;

  const format = (value) => { return String(value); };
  const parse = (value) => { return parseReduxFormValue(value, /[$,]/g); };

  return (
    <Field
      name={name}
      component={DollarInput}
      componentProps={componentProps}
      format={format}
      parse={parse}
      label={label}
    />
  );
};


DollarField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  componentProps: PropTypes.object,
};


DollarField.defaultProps = {
  label: null,
  componentProps: {},
};

/*
* DateInput
 */

export const DateField = (props) => {
  const { componentProps, name, label } = props;

  return (
    <Field
      name={name}
      component={DateInput}
      componentProps={componentProps}
      label={label}
    />
  );
};


DateField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  componentProps: PropTypes.object,
};


DateField.defaultProps = {
  label: null,
  componentProps: {},
};


/*
* PhoneNumber Fields
 */
export const PhoneNumberField = (props) => {
  const { componentProps, name, label } = props;

  return (
    <Field
      name={name}
      component={PhoneNumberInput}
      componentProps={componentProps}
      label={label}
    />
  );
};


PhoneNumberField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  componentProps: PropTypes.object,
};


PhoneNumberField.defaultProps = {
  label: null,
  componentProps: {},
};

/*
* PercentField
 */
export const PercentField = (props) => {
  const { componentProps, name, label } = props;

  const format = (value) => { return String(value); };
  const parse = (value) => { return parseReduxFormValue(value, /[, %]/g); };

  return (
    <Field
      name={name}
      component={PercentInput}
      componentProps={componentProps}
      format={format}
      parse={parse}
      label={label}
    />
  );
};


PercentField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  componentProps: PropTypes.object,
};


PercentField.defaultProps = {
  label: null,
  componentProps: {},
};
